export const cometChatConfig = {
  appID: process.env.REACT_APP_APP_ID,
  region: process.env.REACT_APP_REGION,
  authKey: process.env.REACT_APP_AUTH_KEY,
};

export const homepageUrl = 'https://ome.health/';
